import React from "react";
import './App.css';
import './MatchButton.css';

class MatchButton extends React.Component {
  handleClick = () => {
    // console.log('MatchButton - HandleClick called');
    this.props.onClick();
  }

  render() {
    var cssClasses = "input-text-style match-button match-button-" + (this.props.active ? "active" : "inactive");
    return (
        <button className={cssClasses} disabled={!this.props.active} onClick={this.handleClick}>
          Match!
        </button>
    );
  }
}
export default MatchButton;